import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';
import { AuthService } from '../../authentication/auth.service';
import { DeviceType } from 'src/app/models/device-type/device-type-model';
import { BaseApiService } from '../../base-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class RestDeviceTypesService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  createDeviceType(deviceType: DeviceType): Observable<DeviceType> {
    return this.httpClient.post<DeviceType>(super.getUpsApiHost() + "DeviceTypes", deviceType, {headers : this.authService.upsHttpHeaders});
  }

  updateDeviceType(deviceType: DeviceType): Observable<DeviceType> {
    return this.httpClient.put<DeviceType>(super.getUpsApiHost() + "DeviceTypes/" + deviceType.id, deviceType, {headers : this.authService.upsHttpHeaders});
  }

  deleteDeviceType(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(super.getUpsApiHost() + "DeviceTypes/" + id, {headers : this.authService.upsHttpHeaders});
  }

  getDeviceTypeById(id: number) : Observable<DeviceType> {
    return this.httpClient.get<DeviceType>(super.getUpsApiHost() + "DeviceTypes/" + id, { headers: this.authService.upsHttpHeaders });
  }

  getAllDeviceTypes() : Observable<DeviceType[]>{
    return this.httpClient.get<DeviceType[]>(super.getUpsApiHost() + "DeviceTypes", {headers : this.authService.upsHttpHeaders});
  }
}
